import {ModuleWithProviders} from '@angular/core';
import {mapToCanActivate, mapToCanActivateChild, mapToCanDeactivate, mapToResolve, RouterModule, Routes} from '@angular/router';
import {ClubAttributesComponent} from '~features/club-overview/pages/club-attributes/club-attributes.component';
import {ClubComponent} from '~features/club-overview/pages/club-settings/club.component';
import {CreateCustomerComponent} from '~features/create-customer/pages/create-customer.component';
import {CrmComponent} from '~features/crm/crm.component';
import {CustomerOverviewComponent} from '~features/customer-overview/customer-overview.component';
import {OpenHomeRemindersComponent} from '~features/home-reminders/pages/open-home-reminders.component';
import {ResolvedHomeRemindersComponent} from '~features/home-reminders/pages/resolved-home-reminders.component';
import {HomeComponent} from '~features/home/home.component';
import {LotteryPreparationComponent} from '~features/tixx-select/pages/lottery-preparation/lottery-preparation.component';
import {TixxSelectComponent} from '~features/tixx-select/pages/tixx-select.component';
import {TixxSelectShellComponent} from '~core/routing/tixx-select-shell/tixx-select-shell.component';
import {LoginComponent} from '~features/login/login.component';
import {ClubListComponent} from '~features/manage/club-list/club-list.component';
import {ManageComponent} from '~features/manage/manage.component';
import {UserListComponent} from '~features/manage/user-management/user-list/user-list.component';
import {UserOverviewComponent} from '~features/manage/user-management/user-overview-base/user-overview/user-overview.component';
import {UserOverviewProfileComponent} from '~features/user-overview-profile/user-overview-profile.component';
import {TixxSelectResolver} from 'src/app/core/resolvers';
import {LotteryExecutionComponent} from '~features/tixx-select/pages/lottery-execution/lottery-execution.component';
import {LotteryDashboardComponent} from '~features/tixx-select/pages/lottery-dashboard/lottery-dashboard.component';
import {ClubUserListComponent} from '~features/club-overview/pages/club-user-list/club-user-list.component';
import {CustomerMergeGuard} from 'src/app/core/guards';
import {DeactivateGuard} from 'src/app/core/models';
import {LoginExternalComponent} from '~features/login/components/login-external/login-external.component';
import {CustomerResolver} from '~core/resolvers';
import {ClubSelectedResolver} from '~core/resolvers';
import {AuthChildGuard, ClubAttributesGuard, ClubListGuard, ClubSettingsGuard, UserListGuard} from 'src/app/core/guards';
import {HeaderShellComponent} from '~core/routing/header-shell/header-shell.component';
import {CustomerShellComponent} from '~core/routing/customer-shell/customer-shell.component';
import {ClubShellComponent} from '~core/routing/club-shell/club-shell.component';
import {CustomerMergeProcessComponent} from "~features/customer-merger/pages/customer-merge-process/customer-merge-process.component";
import {MergeCustomerSelectComponent} from "~features/customer-merger/pages/merge-customer-select/merge-customer-select.component";
import {ImportHistoryComponent} from "~features/import-customer/pages/import-history/import-history.component";
import {ImportsComponent} from "~features/import-customer/pages/import-customer.component";
import {SearchCustomerComponent} from "~features/search-customer/pages/search-customer.component";
import {BasicSearchComponent} from "~features/search-customer/pages/basic-search/basic-search.component";
import {AdvancedSearchComponent} from "~features/search-customer/pages/advanced-search/advanced-search.component";
import {EventAdministrationComponent} from "~features/tixx-select/pages/event-administration/event-administration.component";
import {ContactManagementPageComponent} from "~features/customer-overview/pages/contact-management-page/contact-management-page.component";
import {MerchandisingPageComponent} from "~features/customer-overview/pages/merchandising-page/merchandising-page.component";
import {CampaignActivityPageComponent} from "~features/customer-overview/pages/campaign-activity-page/campaign-activity-page.component";
import {TicketingPageComponent} from "~features/customer-overview/pages/ticketing-page/ticketing-page.component";
import {ReminderPageComponent} from "~features/customer-overview/pages/reminder-page/reminder-page.component";
import {TixxSelectPageComponent} from "~features/customer-overview/pages/tixx-select-page/tixx-select-page.component";
import {SepaMandatesPageComponent} from "~features/customer-overview/pages/sepa-mandates-page/sepa-mandates-page.component";
import {MaintenanceComponent} from "~core/routing/maintenance-page/maintenance.component";

const appRoutes: Routes = [
  {path: 'maintenance', component: MaintenanceComponent},
  {path: 'login', component: LoginComponent},
  {path: 'login-external/:token', component: LoginExternalComponent},
  {
    path: '', component: HeaderShellComponent, canActivateChild: mapToCanActivateChild([AuthChildGuard]),
    children: [
      {
        path: 'manage', component: ManageComponent,
        children: [
          {path: 'clubs', component: ClubListComponent, canActivate: mapToCanActivate([ClubListGuard])},
          {path: 'users', component: UserListComponent, canActivate: mapToCanActivate([UserListGuard])},
          {path: 'users/:id', component: UserOverviewComponent},
          {path: '**', redirectTo: 'clubs'}
        ]
      },
      {path: 'user-profile/:id', component: UserOverviewProfileComponent},
      {
        path: 'club/:id', component: ClubShellComponent, resolve: {club: mapToResolve(ClubSelectedResolver)},
        children: [
          {path: 'create-customer', component: CreateCustomerComponent, canDeactivate: mapToCanDeactivate([DeactivateGuard])},
          {path: '', component: HomeComponent},
          {
            path: '', component: CrmComponent,
            children: [
              {
                path: 'customer/:id', component: CustomerShellComponent, resolve: {customer: mapToResolve(CustomerResolver)},
                children: [
                  {path: '', component: CustomerOverviewComponent},
                  {path: 'contacts', component: ContactManagementPageComponent},
                  {path: 'merchandising', component: MerchandisingPageComponent},
                  {path: 'campaigns', component: CampaignActivityPageComponent},
                  {path: 'ticketing', component: TicketingPageComponent},
                  {path: 'reminders', component: ReminderPageComponent},
                  {path: 'tixx-select', component: TixxSelectPageComponent},
                  {path: 'sepa-mandates/:id', component: SepaMandatesPageComponent},
                  {path: '**', redirectTo: ''}
                ]
              },
              {path: 'tixx-select', component: TixxSelectComponent},
              {
                path: 'tixx-select-overview/:id', component: TixxSelectShellComponent, resolve: {selectedLottery: mapToResolve(TixxSelectResolver)},
                children: [
                  {path: '', component: LotteryDashboardComponent},
                  {path: 'event-administration', component: EventAdministrationComponent},
                  {path: 'lottery-preparation', component: LotteryPreparationComponent},
                  {path: 'lottery-execution', component: LotteryExecutionComponent},
                ]
              },
              {path: 'imports', component: ImportsComponent},
              {path: 'import-history', component: ImportHistoryComponent},
              {path: 'merge-customer-select', component: MergeCustomerSelectComponent, canActivate: mapToCanActivate([CustomerMergeGuard])},
              {path: 'merge-customer', component: CustomerMergeProcessComponent, canActivate: mapToCanActivate([CustomerMergeGuard])},
              {path: 'open-reminders', component: OpenHomeRemindersComponent},
              {path: 'resolved-reminders', component: ResolvedHomeRemindersComponent},
              {path: 'settings', component: ClubComponent, canActivate: mapToCanActivate([ClubSettingsGuard])},
              {path: 'attributes', component: ClubAttributesComponent, canActivate: mapToCanActivate([ClubAttributesGuard])},
              {path: 'users', component: ClubUserListComponent},
              {
                path: 'search', component: SearchCustomerComponent,
                children: [
                  {path: 'basic', component: BasicSearchComponent},
                  {path: 'advanced', component: AdvancedSearchComponent},
                  {path: '**', redirectTo: 'basic'}
                ]
              },
            ]
          },
          {path: '**', redirectTo: ''}
        ]
      },
      {path: '**', redirectTo: '/login'}
    ]
  }
];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes, {scrollPositionRestoration: 'enabled'});
